import VehiclesTable from './VehiclesTable';
export default VehiclesTable;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/VehiclesTable/index.js